import { useMutation } from '@tanstack/react-query';
import { ApiError } from '@src/services/api';
import { queryClient, QUERY_KEYS, QUERY_PREFIX } from '@src/query';
import { createCreator, createCreatorBulk } from '../influencers/api';

export const useMutationCreatorCountriesUpdate = () => useMutation<any, ApiError, {
  updates: {
    username: string
    countries: string[]
    countriesToExclude?: string[]
  }[]
}>({
  mutationFn: async ({ updates }) => {
    if (updates.length === 0) {
      return Promise.resolve();
    } else if (updates.length === 1) {
      const { username, countries, countriesToExclude } = updates[0];
      return createCreator({
        username,
        countries,
        countriesToExclude,
        upsert: true,
      });
    } else {
      return createCreatorBulk(updates.map(({ username, countries, countriesToExclude }) => ({
        username,
        countries,
        countriesToExclude,
        upsert: true,
      })));
    }
  },
  onSuccess: async (_) => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.mediaFind() });
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.collectionsMedia() });
    queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX.MEDIA_SIMILAR] });
    queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX.MEDIA_CAROUSEL] });
  },
});
